import React, { useContext } from 'react'
import { TenantContext } from 'tenant/TenantContext'

const StripeResult = ({ formData, paymentData }) => {
    return (<></>)
}

export default StripeResult